import { configureStore } from '@reduxjs/toolkit';

import createReducer from './createReducer';

export const store = configureStore({
  reducer: createReducer(),
});
